import { themeColorMap } from './notebookThemes';
export const backgroundStyleOptions = [
    {
        name: 'Wooden Desk',
        value: 'wooden-desk',
        preview: 'linear-gradient(135deg, #8B4513 0%, #A0522D 25%, #6B4423 50%, #8B4513 75%, #A0522D 100%)',
        description: 'Warm wood grain texture'
    },
    {
        name: 'Dark Navy',
        value: 'dark',
        preview: 'linear-gradient(to bottom, #1a1a2e, #16213e)',
        description: 'Dark navy backdrop'
    },
    {
        name: 'Soft Gradient',
        value: 'soft-gradient',
        preview: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        description: 'Themed color gradient'
    },
    {
        name: 'Cozy Fabric',
        value: 'cozy-fabric',
        preview: 'linear-gradient(to bottom, #d4c4a8, #c9b896)',
        description: 'Soft linen texture'
    },
    {
        name: 'Charcoal',
        value: 'charcoal',
        preview: 'linear-gradient(to bottom, #2d2d2d, #1a1a1a)',
        description: 'Deep charcoal gray'
    },
    {
        name: 'Slate',
        value: 'slate',
        preview: 'linear-gradient(135deg, #475569, #334155, #1e293b)',
        description: 'Cool slate gray'
    },
    {
        name: 'Midnight',
        value: 'midnight',
        preview: 'linear-gradient(to bottom, #0f0f0f, #000000)',
        description: 'Pure black'
    },
    {
        name: 'Graphite',
        value: 'graphite',
        preview: 'linear-gradient(135deg, #374151, #1f2937, #111827)',
        description: 'Modern graphite'
    },
];
export const backgroundColors = [
    { name: 'Default', value: 'default' },
    { name: 'Cream', value: '#fffef5' },
    { name: 'Soft Pink', value: '#fff5f5' },
    { name: 'Mint', value: '#f0fff4' },
    { name: 'Sky', value: '#f0f9ff' },
    { name: 'Lavender', value: '#faf5ff' },
    { name: 'Peach', value: '#fff7ed' },
];
export const fontOptions = [
    { name: 'Handwriting', value: "'Caveat', cursive" },
    { name: 'Serif', value: "'Georgia', serif" },
    { name: 'Sans Serif', value: "'Inter', sans-serif" },
    { name: 'Mono', value: "'Courier New', monospace" },
];
export function getContainerBackground(backgroundStyle, characterColor) {
    const colors = themeColorMap[characterColor] || themeColorMap.lavender;
    switch (backgroundStyle) {
        case 'wooden-desk':
            return {
                background: `
          linear-gradient(135deg,
            #8B4513 0%,
            #A0522D 15%,
            #6B4423 30%,
            #8B4513 45%,
            #A0522D 60%,
            #6B4423 75%,
            #8B4513 100%
          )
        `,
                backgroundSize: '100% 100%',
            };
        case 'dark':
            return {
                background: 'linear-gradient(to bottom, #1a1a2e, #16213e, #0f0f23)',
            };
        case 'soft-gradient':
            return {
                background: `radial-gradient(ellipse at center, ${colors.to}40 0%, ${colors.from}60 50%, ${colors.from}90 100%)`,
            };
        case 'cozy-fabric':
            return {
                background: `
          linear-gradient(to bottom, #d4c4a8, #c9b896, #bea882)
        `,
                backgroundSize: '100% 100%',
            };
        case 'charcoal':
            return {
                background: 'linear-gradient(to bottom, #2d2d2d, #1a1a1a, #0d0d0d)',
            };
        case 'slate':
            return {
                background: 'linear-gradient(135deg, #475569, #334155, #1e293b)',
            };
        case 'midnight':
            return {
                background: 'linear-gradient(to bottom, #0f0f0f, #050505, #000000)',
            };
        case 'graphite':
            return {
                background: 'linear-gradient(135deg, #374151, #1f2937, #111827)',
            };
        default:
            return {
                background: `radial-gradient(ellipse at center, ${colors.to}40 0%, ${colors.from}60 50%, ${colors.from}90 100%)`,
            };
    }
}
